import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Preferences } from '@capacitor/preferences';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-provider-layout',
  templateUrl: './provider-layout.component.html',
  styleUrls: ['./provider-layout.component.scss'],
})
export class ProviderLayoutComponent  implements OnInit {

  showBackButton: boolean = false;
  title: string = ''; 
  displayDate = DateTime.local();
  today = DateTime.local();
  utilityLogo: string = '';

  constructor(
    private router: Router, 
    private location: Location,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private utilityService: UtilityService,
  ) { 
    this.router.events.subscribe(() => {
      this.showBackButton = this.router.url !== '/provider-dash';
      this.updateTitle();
    });
  }

  private updateTitle(): void {
    const currentRoute = this.route.snapshot.firstChild; 
    if (currentRoute) {
      this.title = currentRoute.data['title'] || 'Dashboard'; 
    }
  }

  toDate(): string {
    return this.today.setLocale('en-US').toFormat('d-MMMM-yyyy')
  }

  goBack(): void {
    this.location.back();
  }


  async logout() {
    this.localStorageService.clear();
    await Preferences.clear();
    this.navigateTo('/welcome');
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  async loadLogo() {
    const logoUrl = this.localStorageService.getLogoUrl();
    if (logoUrl) {
      const matches = logoUrl.match(/utilities\/([^\/]+)/);
      if (matches && matches[1]) {
        this.utilityService.loadLogoDataUrl(matches[1], 'assets/Frame 1 .png').subscribe(logo => {
          this.utilityLogo = logo;
        });
        return;
      }
    }
    const utilityId = this.localStorageService.getUtilityId();
    if (utilityId) {
      this.utilityService.loadLogoDataUrl(utilityId, 'assets/Frame 1 .png').subscribe(logo => {
        this.utilityLogo = logo;
      });
      return;
    }
    this.utilityLogo = 'assets/Frame 1 .png';
  }

  ngOnInit() {
    this.loadLogo();
  }
}